import React, { useEffect, useState } from 'react';
import { getContact } from '../services/api';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  const [contact, setContact] = useState({
    phone: '+234 800 NIDAVE', 
    email: 'info@nidave.com', 
    address: "La' Goshen Building, Oluyole industrial Estate, Ibadan", 
    hours: 'Mon - Fri: 8am - 5pm',
    agency: 'sublet@nidave.com'
  });

  useEffect (() => {
    getContact().then(r=>{ if(r.data) setContact(r.data); }).catch(()=>{});
  }, []);
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
              <div className="nav-logo-icon">NIV</div>
              <div><span className="nav-logo-name">NIDAVE</span><span className="nav-logo-tagline">Industrial Ventures Ltd</span></div>
            </div>
            <p className="footer-brand" style={{ fontSize:'0.87rem', lineHeight:1.75, color:'#7a7870', marginTop:'16px', maxWidth:'300px' }}>
              Building reliable infrastructure that supports growth, enhances communities, and exceeds client expectations.
            </p>
          </div>
          <div>
            <div className="footer-heading">Quick Links</div>
            <ul className="footer-links">
              {['About Us','Our Services','Projects','Team','Sublet Portal','Contact'].map(l=><li key={l}><a href="#">{l}</a></li>)}
            </ul>
          </div>
          <div>
            <div className="footer-heading">Services</div>
            <ul className="footer-links">
              {['Road Construction','Building Construction','Road Rehabilitation','Car Park Design','Landscaping','Erosion Control'].map(s=><li key={s}><a href="#about">{s}</a></li>)}
            </ul>
          </div>
          <div>
            <div className="footer-heading">Contact</div>
            <ul className="footer-links">
              <li><a href="tel:{contact.phone}">{contact.phone}</a></li>
              <li><a href="mailto:{contact.email}">{contact.email}</a></li>
              <li><a href="mailto:{contact.agency}">{contact.agency}</a></li>
              <li style={{ color:'#4a4a5a', fontSize:'0.87rem', paddingTop:'4px', cursor:'default' }}>NIDAVE House,<br />Industrial Layout,<br />Nigeria</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-copy">© {year} NIDAVE Industrial Ventures Limited. All rights reserved.</div>
          <div style={{ display:'flex', gap:'20px' }}>
            <a href="https://www.rotneil.com" style={{ color:'#4a4a5a', textDecoration:'none', fontSize:'0.82rem' }}>Powered by Rotneil IT Consult</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
